
export const imgBaseUrl = `${process.env.PUBLIC_URL}/assets/img`;

export const imgUrls = {
    logo: `${imgBaseUrl}/logo.png`,
    aboutUsBanner: `${imgBaseUrl}/contact-us.jpg`,
    contactUsBanner: `${imgBaseUrl}/contact-us.jpg`,
    // Slides Images
    slide1: `${imgBaseUrl}/slides/slide1.jpg`,
    slide2: `${imgBaseUrl}/slides/slide2.jpg`,
    slide3: `${imgBaseUrl}/slides/slide3.jpg`,
    // Products Images
    productsImg1: `${imgBaseUrl}/products/colour-printing.jpg`,
    productsImg2: `${imgBaseUrl}/products/icard-printing.jpg`,
    productsImg3: `${imgBaseUrl}/products/lamination.jpg`,
    productsImg4: `${imgBaseUrl}/products/laser-print.jpg`,
    productsImg5: `${imgBaseUrl}/products/xerox-bw-printout.jpg`,
    productsImg6: `${imgBaseUrl}/products/colour-printing.jpg`,
}
